// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_screen__XQJyW > div {
  height: 100vh; }

.styles_modalContent__knZS8 {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem;
  gap: 1.5rem; }

.styles_modalTitle__384Y5 {
  text-align: center;
  margin-bottom: 0.5rem; }

.styles_imageContainer__OlG-P {
  padding: 1rem; }

.styles_emptyImage__zEJu1 {
  width: 12rem;
  height: 12rem;
  object-fit: contain; }

.styles_emptyText__Glcth {
  text-align: center;
  font-size: 1rem;
  color: var(--text-secondary);
  max-width: 24rem; }

.styles_subText__\\+mycX {
  font-size: 0.875rem;
  margin-top: -0.5rem; }

.styles_createButton__eeS8g {
  margin-top: 0.5rem;
  padding: 0.75rem 2rem;
  font-size: 1rem; }

.styles_userGuide__tMIUO {
  position: fixed;
  top: 1.5rem;
  right: 1.5rem;
  z-index: 1000;
  max-width: 22rem; }

.styles_guideContent__vm3FE {
  background: var(--bg-2);
  border-radius: 0.5rem;
  padding: 1rem;
  min-height: 4rem;
  box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.1);
  border: 0.125rem solid #72abab; }

.styles_guideHeader__xkiOM {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 0.75rem; }

.styles_guideMainText__s-7jY {
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.25;
  flex: 1 1; }

.styles_guideSubText__pJnVo {
  font-size: 0.75rem;
  color: var(--text-secondary);
  margin-top: 0.625rem;
  line-height: 1.5; }

button.styles_closeButton__qrJVx {
  flex-shrink: 0;
  width: 1.5rem;
  height: 1.5rem;
  min-width: 1.5rem;
  padding: 0;
  font-size: 1.5rem;
  line-height: 1;
  background: transparent;
  border: none;
  cursor: pointer;
  opacity: 0.5;
  transition: opacity 0.2s;
  margin: -0.25rem -0.25rem 0 0; }
  button.styles_closeButton__qrJVx:hover {
    opacity: 1;
    background: transparent; }
`, "",{"version":3,"sources":["webpack://./src/modules/shelter/components/UserGuide/styles.module.scss","webpack://./src/modules/Core/styles/variables.scss"],"names":[],"mappings":"AAGA;EAEI,aAAa,EAAA;;AAIjB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,WAAW,EAAA;;AAGb;EACE,kBAAkB;EAClB,qBAAqB,EAAA;;AAGvB;EACE,aAAa,EAAA;;AAGf;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB,EAAA;;AAGrB;EACE,kBAAkB;EAClB,eAAe;EACf,4BAA4B;EAC5B,gBAAgB,EAAA;;AAGlB;EACE,mBAAmB;EACnB,mBAAmB,EAAA;;AAGrB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,eAAe,EAAA;;AAGjB;EACE,eAAe;EACf,WAAW;EACX,aAAa;EACb,aAAa;EACb,gBAAgB,EAAA;;AAGlB;EACE,uBAAuB;EACvB,qBAAqB;EAErB,aAAa;EACb,gBAAgB;EAChB,gDAAgD;EAChD,8BC1BkB,EAAA;;AD6BpB;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,YAAY,EAAA;;AAGd;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,SAAO,EAAA;;AAGT;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,oBAAoB;EACpB,gBAAgB,EAAA;;AAGlB;EACE,cAAc;EACd,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,UAAU;EACV,iBAAiB;EACjB,cAAc;EACd,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,wBAAwB;EACxB,6BAA6B,EAAA;EAb/B;IAgBI,UAAU;IACV,uBAAuB,EAAA","sourcesContent":["@import \"src/modules/Core/styles/variables.scss\";\n\n\n.screen {\n  & > div {\n    height: 100vh;;\n  }\n}\n\n.modalContent {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 2rem;\n  gap: 1.5rem;\n}\n\n.modalTitle {\n  text-align: center;\n  margin-bottom: 0.5rem;\n}\n\n.imageContainer {\n  padding: 1rem;\n}\n\n.emptyImage {\n  width: 12rem;\n  height: 12rem;\n  object-fit: contain;\n}\n\n.emptyText {\n  text-align: center;\n  font-size: 1rem;\n  color: var(--text-secondary);\n  max-width: 24rem;\n}\n\n.subText {\n  font-size: 0.875rem;\n  margin-top: -0.5rem;\n}\n\n.createButton {\n  margin-top: 0.5rem;\n  padding: 0.75rem 2rem;\n  font-size: 1rem;\n}\n\n.userGuide {\n  position: fixed;\n  top: 1.5rem;\n  right: 1.5rem;\n  z-index: 1000;\n  max-width: 22rem;\n}\n\n.guideContent {\n  background: var(--bg-2);\n  border-radius: 0.5rem;\n  // padding: 1.25rem;\n  padding: 1rem;\n  min-height: 4rem;\n  box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.1);\n  border: 0.125rem solid $ocean_blue;\n}\n\n.guideHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 0.75rem;\n}\n\n.guideMainText {\n  font-size: 1rem;\n  font-weight: 700;\n  line-height: 1.25;\n  flex: 1;\n}\n\n.guideSubText {\n  font-size: 0.75rem;\n  color: var(--text-secondary);\n  margin-top: 0.625rem;\n  line-height: 1.5;\n}\n\nbutton.closeButton {\n  flex-shrink: 0;\n  width: 1.5rem;\n  height: 1.5rem;\n  min-width: 1.5rem;\n  padding: 0;\n  font-size: 1.5rem;\n  line-height: 1;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  opacity: 0.5;\n  transition: opacity 0.2s;\n  margin: -0.25rem -0.25rem 0 0;\n\n  &:hover {\n    opacity: 1;\n    background: transparent;\n  }\n}","// @import \"src/modules/Core/styles/variables.scss\";\n\n$white90: #ffffffe6;\n$green50: #00800080;\n\n$white10: #ffffff1a;\n$white18: #ffffff2e;\n$white50: #ffffff80;\n\n$grey3:#80808008;\n$grey5: #8080800d;\n$grey7: #80808012;\n$grey10: #8080801a;\n$grey18: #8080802e;\n$grey36: #8080805c;\n$grey50: #80808080;\n$grey54: #8080808a;\n$grey72: #808080b8;\n$grey90: #808080e6;\n$grey: #808080;\n\n\n$purple100: #800080;\n$purple90: #800080e6;\n$purple72:#800080b8;\n$purple50: #80008080;\n$purple36: #8000805c;\n$purple18: #8000802e;\n\n$dark_purple: #480048;\n$deep_purple: #840000;\n\n$baby_blue: #87ceeb;\n$ui_blue: #1976d2;\n$ui_blue90: #1976d2e6;\n$ui_blue72: #1976d2b8;\n$ui_blue50: #1976d280;\n$pond_green: #72bbbb;\n$pond_green72: #72bbbbb8;\n$ocean_blue: #72abab;\n$ocean_blue90: #72ababe6;\n$ocean_blue72: #72ababb8;\n$ocean_blue50: #72abab80;\n$ocean_blue36: #72abab5c;\n$ocean_blue10: #73abab1a;\n$kermit_green: #72ab72;\n$kermit_green72: #72ab72b8;\n$somewhat_certain:#183672;\n$just_say_ok: #721446;\n$success_street: #723618;\n\n$golden: #ffd700;\n$_golden: #D4AF37;\n$bronze: #cd7f32;\n\n$bronze80: #cd7f32c2;\n$bronze50: #cd7f3280;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"screen": `styles_screen__XQJyW`,
	"modalContent": `styles_modalContent__knZS8`,
	"modalTitle": `styles_modalTitle__384Y5`,
	"imageContainer": `styles_imageContainer__OlG-P`,
	"emptyImage": `styles_emptyImage__zEJu1`,
	"emptyText": `styles_emptyText__Glcth`,
	"subText": `styles_subText__+mycX`,
	"createButton": `styles_createButton__eeS8g`,
	"userGuide": `styles_userGuide__tMIUO`,
	"guideContent": `styles_guideContent__vm3FE`,
	"guideHeader": `styles_guideHeader__xkiOM`,
	"guideMainText": `styles_guideMainText__s-7jY`,
	"guideSubText": `styles_guideSubText__pJnVo`,
	"closeButton": `styles_closeButton__qrJVx`
};
export default ___CSS_LOADER_EXPORT___;
